// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { useUserContext } from '@ion/user';
import SideNav from 'app/components/side-nav';
import Header from 'app/components/app-header';
import ProfileDetails from 'app/settings/profile/details.js';
import { MrAppLayout, MrTab, MrHeaderTabs, MrTabList, MrTabPanel } from '@ion/components';

import { ConsentCategoryPage } from './consent-page/consentCategoriesPage';
import { ConsentCategoriesTableContext } from './consent-page/context/consentCategoriesTableContext';

import { UserManagementPage } from './user-management-page/UserManagementPage';
import { OrganizationOverridePage } from './organization-override-page/OrganizationOverridePage';

import WebhookSettingsPage from './webhook-settings-page/WebhookSettingsPage';
import TagsPage from './tags-page/TagsPage';
import useSettingsFlags from './hooks/useSettingsFlags';
import isAllowedToOverrideOrganization from './organization-override-page/is-allowed-to-override-organization';

const SettingsPage = () => {
  const { user } = useUserContext();
  const { hasConsent, hasWebhooks, hasTags } = useSettingsFlags();
  const hasPermission = isAllowedToOverrideOrganization();

  return (
    <MrAppLayout title="Settings" header={<Header icon="settings" title="Settings" />} sideNav={<SideNav />}>
      <MrHeaderTabs>
        <MrTabList>
          <MrTab>General</MrTab>
          {hasConsent && <MrTab>Advanced Consent Enforcement</MrTab>}
          {hasTags && <MrTab>Tags</MrTab>}
          {hasWebhooks && <MrTab>Webhooks</MrTab>}
          <MrTab>User Management</MrTab>
          {hasPermission && <MrTab>Org Override</MrTab>}
        </MrTabList>

        <MrTabPanel>
          <ProfileDetails me={user} />
        </MrTabPanel>

        {hasConsent && (
          <MrTabPanel>
            <ConsentCategoriesTableContext>
              <ConsentCategoryPage />
            </ConsentCategoriesTableContext>
          </MrTabPanel>
        )}

        {hasTags && (
          <MrTabPanel>
            <TagsPage />
          </MrTabPanel>
        )}

        {hasWebhooks && (
          <MrTabPanel>
            <WebhookSettingsPage />
          </MrTabPanel>
        )}

        <MrTabPanel>
          <UserManagementPage />
        </MrTabPanel>

        {hasPermission && (
          <MrTabPanel>
            <OrganizationOverridePage />
          </MrTabPanel>
        )}
      </MrHeaderTabs>
    </MrAppLayout>
  );
};

export default SettingsPage;
